import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import __ from 'utils/i18n';

export const PanelFooter = ({ isEdition, sameUser, isFetching, showDeleteModal, touched }) => {

  return (
    <Row>
      <Col md='12'>
        <Button
          color='danger'
          type='button'
          block={true}
          onClick={() => { showDeleteModal(true); }}
          disabled={isFetching}
        >
          <i className='mdi mdi-delete' />
          {__('actions.delete')}
        </Button>
      </Col>
    </Row>
  );
};
